export default __webpack_public_path__ + "static/media/330_business01-jp-mobile.a3d6ca44.png";